import React from "react";
import { Container } from "reactstrap";
import ReactPlayer from "react-player/lazy"; // Use lazy loading version of ReactPlayer
import BlockTitle from "components/shared/BlockTitle";

const VideoBlock = (props) => {
    const { title, video } = props.block;

    if (!video) return null;

    return (
        <Container className="py-4" style={{ height: "100vh" }}>
            {title && <BlockTitle>{title}</BlockTitle>}

            {typeof window !== "undefined" && ( // Ensure it only renders on the client
                <div
                    style={{
                        position: "relative",
                        paddingBottom: "56.25%", // Maintain 16:9 aspect ratio
                        height: 0,
                        overflow: "hidden",
                        width: "100%",
                    }}
                >
                    <ReactPlayer
                        url={video}
                        controls={true}
                        className="react-player"
                        style={{ position: "absolute", top: 0, left: 0 }}
                        width="100%"
                        height="100%"
                    />
                </div>
            )}
        </Container>
    );
};

export default VideoBlock;